import { useQuery } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { GET_AMI_INCOME_LIMITS_PATH } from 'src/services/api/ami/constants';
import type { IAmiIncomeLimitsResponse } from 'src/services/api/ami/types';

const fetchAmiIncomeLimits = async (
    countyFips: string,
    householdSize?: number | null
): Promise<IAmiIncomeLimitsResponse> => {
    const searchParams = new URLSearchParams();
    searchParams.append('county_fips', countyFips);
    if (householdSize) {
        searchParams.append('household_size', String(householdSize));
    }

    return apiClient(GET_AMI_INCOME_LIMITS_PATH, { searchParams }).json<IAmiIncomeLimitsResponse>();
};

/**
 * Fetch global AMI income limits for a county from the release currently in
 * effect. Pass a household size to get just that size (sizes above 8 are
 * derived server-side with HUD's formula); omit it for the full 1-8 grid.
 *
 * Disabled until a county FIPS is provided.
 */
export const useAmiIncomeLimits = (countyFips?: string | null, householdSize?: number | null) => {
    return useQuery<IAmiIncomeLimitsResponse>(
        [queryKeys.amiIncomeLimits, countyFips, householdSize],
        async () => fetchAmiIncomeLimits(countyFips as string, householdSize),
        { enabled: !!countyFips }
    );
};
